import screenfull from "screenfull";
import videojs from "video.js";

import theaterModeIcon from "./icon/theaterModeIcon.svg";

import type Player from "video.js/dist/types/player";

type TheaterModeIvsButtonOptions = {
  isTheaterModeEnabled: boolean;
  toggleTheaterMode: () => void;
};

export const getTheaterModeIvsButton = () => {
  const VideoJSButton = videojs.getComponent("Button");

  class TheaterModeIvsButton extends VideoJSButton {
    constructor(player: Player, options = {}) {
      super(player, options);

      document.addEventListener(
        "fullscreenchange",
        this.handleChangeForScreenfull
      );

      if (screenfull.isEnabled) {
        screenfull.on("change", this.handleChangeForScreenfull);
      }

      player.on("dispose", () => {
        document.removeEventListener(
          "fullscreenchange",
          this.handleChangeForScreenfull
        );

        if (screenfull.isEnabled) {
          screenfull.off("change", this.handleChangeForScreenfull);
        }
      });
    }

    handleChangeForScreenfull = () => {
      if (
        this.player().isFullscreen() ||
        (screenfull.isEnabled && screenfull.isFullscreen)
      ) {
        this.hide();
      } else {
        this.show();
      }
    };

    handleClick() {
      const options = this.options(undefined) as TheaterModeIvsButtonOptions;
      options.toggleTheaterMode();
    }

    createEl() {
      return videojs.dom.createEl("button", {
        className:
          "vjs-custom-theater-mode-button vjs-custom-button vjs-control vjs-button",
        innerHTML: `<img src="${theaterModeIcon}" alt="Theater Mode Button"/><span class="vjs-control-text">シアターモード</span>`,
        title: "Theater mode",
      });
    }
  }

  return TheaterModeIvsButton;
};
